const config = {
    apiRoot: window.location.protocol + '//' + window.location.host + '/api/v1',
    root: window.location.protocol + '//' + window.location.host,
    websockets: 'wss://' + window.location.host + ':28080',
};
export default config;
